/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h1[_ngcontent-%COMP%]{color:#338141;margin-bottom:30px;margin-top:10px}h1.return-day[_ngcontent-%COMP%]{margin-top:30px}@media only screen and (max-width:767px){h1[_ngcontent-%COMP%]{text-align:center;margin-bottom:15px;font-weight:800;letter-spacing:-1px}h1.return-day[_ngcontent-%COMP%]{margin-top:5px}}"];
export { styles as styles };
